import { render, staticRenderFns } from "./OnlyBoarding.vue?vue&type=template&id=64dd7c30&scoped=true&"
import script from "./OnlyBoarding.vue?vue&type=script&lang=js&"
export * from "./OnlyBoarding.vue?vue&type=script&lang=js&"
import style0 from "./OnlyBoarding.vue?vue&type=style&index=0&id=64dd7c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd7c30",
  null
  
)

export default component.exports